import React from 'react';
import { Switch, Redirect } from 'react-router-dom';

import { RouteWithLayout } from './components';
import {
  Main as MainLayout,
  Minimal as MinimalLayout,
  Minimalistic as MinimalisticLayout
} from './layouts';

import {
  Settings as SettingsView,
  SignUp as SignUpView,
  SignIn as SignInView,
  NotFound as NotFoundView,
  Terms as TermsView,
  Forgot as ForgotView,
  Default as DefaultView,
  PTMessage as PTMessageView,
  PTSchedule as PTScheduleView,
  Template as TemplateView,
  Communication as CommunicationView,
  RegisterPractice as RegisterPracticeView
} from './views';

const Routes = () => {
  return (
    <Switch>
      <Redirect exact from="/" to="/sign-in" />
      <RouteWithLayout
        component={SettingsView}
        exact
        layout={MainLayout}
        path="/settings"
      />
      <RouteWithLayout
        component={SignUpView}
        exact
        layout={MinimalLayout}
        path="/sign-up"
      />
      <RouteWithLayout
        component={SignInView}
        exact
        layout={MinimalLayout}
        path="/sign-in"
      />
      <RouteWithLayout
        component={NotFoundView}
        exact
        layout={MinimalLayout}
        path="/not-found"
      />
      <RouteWithLayout
        component={TermsView}
        exact
        layout={MinimalisticLayout}
        path="/terms"
      />
      <RouteWithLayout
        component={ForgotView}
        exact
        layout={MinimalisticLayout}
        path="/forgot/:pw?"
      />
      <RouteWithLayout
        component={DefaultView}
        exact
        layout={MainLayout}
        path="/default"
      />
      <RouteWithLayout
        component={CommunicationView}
        exact
        layout={MainLayout}
        path="/communications"
      />
      <RouteWithLayout
        component={PTMessageView}
        exact
        layout={MainLayout}
        path="/pt-message"
      />
      <RouteWithLayout
        component={PTScheduleView}
        exact
        layout={MainLayout}
        path="/pt-schedule"
      />
      {/* <RouteWithLayout
        component={TemplateView}
        exact
        layout={MainLayout}
        path="/template"
      /> */}
      <RouteWithLayout
        layout={MinimalLayout}
        path="/register-practice"
        exact
        component={RegisterPracticeView}
      />
      <Redirect to="/not-found" />
    </Switch>
  );
};

export default Routes;
